const FACEBOOK_URL = 'https://www.facebook.com/GostilnaMarta';

export default function FacebookFollow() {
  return (
    <section className="relative bg-background-50 py-14 md:py-20">
      <div className="w-full px-5 md:px-10 lg:px-14">
        <div className="max-w-4xl mx-auto">
          <div className="relative overflow-hidden rounded-lg border border-background-200/70 bg-background-100 px-6 py-10 md:px-12 md:py-12">
            <div className="absolute -top-14 -left-14 w-40 h-40 rounded-full bg-secondary-100/60 blur-2xl pointer-events-none" />

            <div className="relative flex flex-col md:flex-row items-center gap-6 md:gap-8 text-center md:text-left">
              <div
                className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-lg shrink-0"
                style={{ backgroundColor: '#1877F2' }}
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-white text-4xl md:text-5xl"></i>
              </div>

              <div className="flex-1">
                <p className="font-label text-xs tracking-extra-wide text-accent-600 font-medium uppercase mb-2">
                  SPREMLJAJTE NAS
                </p>
                <h2 className="font-heading text-2xl md:text-3xl font-light text-foreground-950 mb-2">
                  Gostilna Marta na Facebooku
                </h2>
                <p className="font-body text-sm text-foreground-600 leading-relaxed">
                  Novosti, dnevna ponudba in utrinki iz gostilne ter sob — všečkajte stran in ostanite na tekočem.
                </p>
              </div>

              <a
                href={FACEBOOK_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 w-full md:w-auto px-7 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-950 text-xs md:text-sm font-label font-semibold tracking-extra-wide transition-all duration-300 whitespace-nowrap cursor-pointer rounded-sm shrink-0"
              >
                <i className="ri-facebook-circle-fill text-base"></i>
                ODPRI FACEBOOK STRAN
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}